export const SCORE_TOOLTIP_FORMAT = {
	ACTUAL: 'actual',
	PERCENT: 'percent',
}
